import React, { forwardRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import clsx from 'clsx'

import PerfectScrollbar from 'react-perfect-scrollbar'
import { makeStyles } from '@material-ui/styles'
import { Card, CardContent, CircularProgress } from '@material-ui/core'
import MaterialTable from 'material-table'

import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import LastPageIcon from '@material-ui/icons/LastPage'
import useRouter from 'utils/useRouter'
import moment from 'moment'
import localization from 'moment/locale/pt-br'

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0,
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  inner: {
    minWidth: 700,
  },
  nameCell: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1),
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: 'flex-end',
  },
}))

export const Results = (props) => {
  const { className, dados, processando, ...rest } = props
  const router = useRouter()
  moment.locale('pt-br', localization)
  const classes = useStyles()
  const handleRowClick = (id) => {
    router.history.push(`/casos/caso/detalhar/${id}`)
  }

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Card>
        {processando ? (
          <div className={classes.carregando}>
            <CircularProgress disableShrink />
          </div>
        ) : (
          <CardContent className={classes.content}>
            <PerfectScrollbar>
              <div className={classes.inner}>
                <MaterialTable
                  localization={{
                    pagination: {
                      labelDisplayedRows: '{from}-{to} de {count}',
                      labelRowsSelect: 'linhas',
                      nextTooltip: 'Página seguinte',
                      previousTooltip: 'Página anterior',
                      lastTooltip: 'Última página',
                      firstTooltip: 'Primeira página',
                    },
                    toolbar: {
                      nRowsSelected: '{0} linha(s) selecionadas',
                      searchPlaceholder: 'Buscar',
                    },
                    header: {
                      actions: 'Ações',
                    },
                    body: {
                      emptyDataSourceMessage: 'Nada para mostrar',
                      filterRow: {
                        filterTooltip: 'Filtro',
                      },
                    },
                  }}
                  title=""
                  columns={[
                    {
                      title: 'Identificador',
                      field: 'identificador',
                    },
                    {
                      title: 'Descrição',
                      field: 'descricao',
                    },
                    {
                      title: 'Órgão responsável',
                      field: 'setRes.nome',
                    },
                    {
                      title: 'Data e hora do cadastro',
                      field: 'data',
                      type: 'date',
                      render: (rowData) => moment(rowData.createdAt).format('LLLL'),
                      defaultSort: 'desc',
                    },
                  ]}
                  data={dados}
                  onRowClick={(event, rowData) => handleRowClick(rowData.id)}
                  options={{
                    actionsColumnIndex: -1,
                    search: true,
                    pageSize: 10,
                    searchFieldStyle: {
                      flexGrow: 1,
                      height: 42,
                      display: 'flex',
                      alignItems: 'center',
                    },
                    headerStyle: {
                      backgroundColor: '#f4f6f8',
                    },
                  }}
                  icons={{
                    SortArrow: forwardRef((propsSortArrow, ref) => <ArrowDownwardIcon {...propsSortArrow} ref={ref} />),
                    Search: forwardRef((propsSearch, ref) => <SearchIcon {...propsSearch} ref={ref} />),
                    ResetSearch: forwardRef((propsResetSearch, ref) => <ClearIcon {...propsResetSearch} ref={ref} />),
                    NextPage: forwardRef((propsNextPage, ref) => <NavigateNextIcon {...propsNextPage} ref={ref} />),
                    PreviousPage: forwardRef((propsPreviousPage, ref) => <NavigateBeforeIcon {...propsPreviousPage} ref={ref} />),
                    FirstPage: forwardRef((propsFirstPage, ref) => <FirstPageIcon {...propsFirstPage} ref={ref} />),
                    LastPage: forwardRef((propsLastPage, ref) => <LastPageIcon {...propsLastPage} ref={ref} />),
                  }}
                  style={{
                    padding: '16px',
                    fontSize: '13px',
                    textAlign: 'left',
                    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                    fontWeight: '400',
                    lineHeight: '21px',
                    borderBottom: '1px solid #eeeeee',
                    letterSpacing: '-0.05px',
                    verticalAlign: 'inherit',
                  }}
                />
              </div>
            </PerfectScrollbar>
          </CardContent>
        )}
      </Card>
    </div>
  )
}
